/**
 * @generated SignedSource<<7ddda2a4b17eec333f90d2ef9c5f2022>>
 * @relayHash ee02cd6160cc1cfee6fa6d1fba84a159
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4fde877dd091b461b191c46c59a002d0bc95ac007ed500e5c0f27905f57ca0a2

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ContentDataClassificationMutationContentStatus = "CURRENT" | "DRAFT" | "%future added value";
export type useContentClassificationBulkDeleteContentDataClassificationLevelMutation$variables = {
  contentStatuses: ReadonlyArray<ContentDataClassificationMutationContentStatus | null | undefined>;
  id: AGG$Long;
};
export type useContentClassificationBulkDeleteContentDataClassificationLevelMutation$data = {
  readonly bulkDeleteContentDataClassificationLevel: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useContentClassificationBulkDeleteContentDataClassificationLevelMutation = {
  response: useContentClassificationBulkDeleteContentDataClassificationLevelMutation$data;
  variables: useContentClassificationBulkDeleteContentDataClassificationLevelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentStatuses"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentStatuses",
            "variableName": "contentStatuses"
          },
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "BulkDeleteContentDataClassificationLevelPayload",
    "kind": "LinkedField",
    "name": "bulkDeleteContentDataClassificationLevel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "ee02cd6160cc1cfee6fa6d1fba84a159",
    "id": "4fde877dd091b461b191c46c59a002d0bc95ac007ed500e5c0f27905f57ca0a2",
    "metadata": {},
    "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
    "operationKind": "mutation",
    "text": "mutation useContentClassificationBulkDeleteContentDataClassificationLevelMutation($id:Long!,$contentStatuses:[ContentDataClassificationMutationContentStatus]!){bulkDeleteContentDataClassificationLevel(input:{id:$id,contentStatuses:$contentStatuses}){success,errors{message}}}"
  }
};
})();

(node as any).hash = "482a842e925e6082fc32c6749e95ba4b";

export default node;
